import { useMutation, useQueryClient } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { LikeCommunityStrategy } from 'services/apiServices';
import {
  TLikeStrategyResult,
  Errors,
} from 'types/ApiServicesTypes';

export default function useLikeCommunityStrategy() {
  const { showAlert } = useContext(ToastContext);
  const queryClient = useQueryClient();

  const mutation = useMutation<TLikeStrategyResult, Errors, number>(
    ['LikeCommunityStrategy'],
    strategyId =>
      LikeCommunityStrategy(strategyId)
        .then(res => {
          // Invalidate and refetch strategies list and specific strategy
          void queryClient.invalidateQueries(['GetCommunityStrategies']);
          void queryClient.invalidateQueries(['GetCommunityStrategy', strategyId]);
          return res;
        })
        .catch(err => {
          showAlert!(err.message as string);
          return err;
        }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
} 